const roundLastThreeToZero = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  if (value < 1000) return value;
  return Math.floor(value / 1000) * 1000;
};

export default roundLastThreeToZero;

export const ceilToNextThousand = (value: number) =>
  Math.ceil(value / 1000) * 1000;
